import constants from '@/assets/environments/constants.json';

export default {
    methods: {
        userLoginDestiny(session) {
            var rol = session.get('rol')
            var destiny = constants.routerContracts

            if (rol && rol == constants.roleSuperAdmin){
                destiny = constants.routerContracts
            }
            return destiny
        }
    }
}



// WEBPACK FOOTER //
// ./src/securityMixin.js